import { render, staticRenderFns } from "./UserAgreement.vue?vue&type=template&id=a8e3d09a&scoped=true"
import script from "./UserAgreement.vue?vue&type=script&lang=js"
export * from "./UserAgreement.vue?vue&type=script&lang=js"
import style0 from "./UserAgreement.vue?vue&type=style&index=0&id=a8e3d09a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8e3d09a",
  null
  
)

export default component.exports